export default "__VITE_ASSET__751e467a__"